module.exports = __webpack_public_path__ + "img/16_84.cc12b58d.png";